/*
 * @Description:
 * @LastEditors: Please set LastEditors
 * @Date: 2020-11-10 13:57:25
 */
import tobeOpendPart from './tobeOpened';
import kaipiaojilu from './kaipiaojilu';
import invoiceUpload from './invoiceUpload';

// 账号如果没有运营基地类型项目，则不显示该菜单
export default [
  { name: '未开票订单', childMenu: [tobeOpendPart] },
  { name: '开票记录', childMenu: [kaipiaojilu] }
];
export const uploadI = { name: '发票上传', childMenu: [invoiceUpload] };
